import { useEffect, useState } from 'react'
import { EditorialMedia } from './EditorialMedia'
import { SectionHeading } from './SectionHeading'
import { SmartLink } from './SmartLink'
import { usePreviewSelection } from './usePreviewSelection'
import { useLanguage } from '../i18n'

function CaseVisual({ mobile = false, index, label }: { mobile?: boolean; index: number; label: string }) {
  return (
    <div className={`case-panel__visual ${mobile ? 'case-panel__visual--mobile' : 'case-panel__visual--desktop'}`}>
      <EditorialMedia alt="" index={index} className="case-panel__media" label={label} />
      <p>Estrutura → Tecnologia → Pessoas → Capacidade → Resultado</p>
    </div>
  )
}

export function Cases() {
  const { copy } = useLanguage()
  const cases = copy.cases.items
  const selection = usePreviewSelection()
  const activeCase = cases[selection.activeIndex]
  const [mobileLayout, setMobileLayout] = useState(() => window.matchMedia('(max-width: 900px)').matches)

  useEffect(() => {
    const media = window.matchMedia('(max-width: 900px)')
    const update = () => setMobileLayout(media.matches)
    media.addEventListener('change', update)
    return () => media.removeEventListener('change', update)
  }, [])

  return (
    <section id="cases" className="section section--light cases" aria-labelledby="cases-title">
      <div className="container">
        <SectionHeading
          id="cases-title"
          kicker={copy.cases.kicker}
          title={copy.cases.title}
          mobileTitle={copy.cases.mobileTitle}
          introduction={copy.cases.introduction}
        />

        <div className="case-workbench">
          <div ref={selection.scopeRef} className="case-tabs" role="tablist" aria-label={copy.cases.selectorLabel}>
            <span className="case-tabs__label">{copy.cases.projects}</span>
            {cases.map((item, index) => (
              <button
                key={item.name}
                type="button"
                role="tab"
                id={`case-tab-${index}`}
                aria-controls="case-panel"
                aria-selected={selection.selectedIndex === index}
                className={selection.activeIndex === index ? 'active' : ''}
                onMouseEnter={() => selection.preview(index)}
                onFocus={() => selection.preview(index)}
                onClick={() => selection.commit(index)}
              >
                <span>{String(index + 1).padStart(2, '0')}</span>
                {item.name}
              </button>
            ))}
          </div>

          <CaseVisual index={selection.activeIndex} label={copy.cases.mediaLabel} />

          <article id="case-panel" className="case-panel__content" key={activeCase.name} role="tabpanel" aria-labelledby={`case-tab-${selection.activeIndex}`}>
            <span className="case-eyebrow">{activeCase.eyebrow}</span>
            <h3>{activeCase.title}</h3>
            <p className="case-intro">{activeCase.introduction}</p>
            <CaseVisual mobile index={selection.activeIndex} label={copy.cases.mediaLabel} />

            <details className="case-structure" key={`${activeCase.name}-${mobileLayout}`} open={!mobileLayout}>
              <summary>{copy.cases.structure}</summary>
              <ul>{activeCase.structure.map((item) => {
                const label = typeof item === 'string' ? item : item.label
                if (typeof item === 'string') return <li key={label}>{item}</li>
                return (
                  <li key={label}>
                    <SmartLink
                      href={item.href}
                    >
                      {item.label}
                    </SmartLink>
                  </li>
                )
              })}</ul>
            </details>

            <div className="case-results">
              {activeCase.results.map((result) => (
                <div key={`${result.value}-${result.label}`}>
                  <strong>{result.value}</strong>
                  {result.label && <span>{result.label}</span>}
                </div>
              ))}
            </div>

            <p className="case-conclusion">{activeCase.conclusion}</p>
            <a className="text-link text-link--dark" href="#consultoria">{copy.cases.cta} <span aria-hidden="true">→</span></a>
          </article>
        </div>

        <div className="cases-closing">
          <span>{copy.cases.closingLabel}</span>
          <strong>{copy.cases.closingTitle}</strong>
          <p>{copy.cases.closingText}</p>
        </div>
      </div>
    </section>
  )
}
